<template>
  <div>
    <div>
      <div v-if="tela != undefined">
        <div class="row col-12 text-brand-5">
          <Transition name="expansivel">
            <div class="row col-12 q-mt-md q-pa-md">
              <div
                class="row col-12 justify-center"
                v-for="(array, index) in arrayObjetos"
                :key="index"
              >
                <div
                  class="row col-12 justify-center q-mt-md"
                  v-if="array.primario == false"
                >
                  <q-icon name="arrow_downward" size="30px"></q-icon>
                </div>
                <q-card
                  style="
                    border: 1px solid #787878;
                    border-radius: 20px;
                    position: relative;
                  "
                  :style="{
                    'border-color':
                      ativosErrosIndicator &&
                      ativosErrosIndicator.indexOf(array.patrimonio) != -1
                        ? 'red'
                        : '',
                  }"
                  :id="`card-${index}`"
                  :class="{
                    'row col-11 q-mt-md card-expansivel color-red':
                      array.primario == false,
                    'row col-12 q-mt-md card-expansivel color-red':
                      array.primario == undefined || array.primario == true,
                  }"
                >
                  <div
                    v-if="botaoRemover"
                    style="position: absolute; left: 15px; top: 10px"
                  >
                    <span class="texto-index-card">
                      <span class="text-bold"> Item: </span>
                      <span>
                        {{ index + 1 }}
                      </span>
                    </span>
                  </div>
                  <div class="row col-12 q-pa-md">
                    <div class="col-1" style="align-self: center">
                      <q-btn
                        color="red"
                        v-if="botaoRemover"
                        round
                        icon="close"
                        :size="mobile ? 'md' : ''"
                        :disable="disable"
                        @click.stop="removerAtivo(array, index)"
                      />
                      <div v-else>
                        <span class="texto-index-card">
                          <span class="text-bold"> Item: </span>
                          <span>
                            {{ index + 1 }}
                          </span>
                        </span>
                      </div>
                    </div>
                    <div class="col texto-colunas">
                      <div class="row col-12 q-gutter-sm">
                        <div class="col-2">
                          <div class="text-brand-5 text-weight-bold">
                            Código
                          </div>
                          <div class="text-brand-5">
                            {{
                              array?.catalogoItem?.codigo ||
                              array?.codigo ||
                              array?.catalogoItemCodigo
                            }}
                          </div>
                        </div>
                        <div class="col">
                          <div class="text-brand-5 text-weight-bold">
                            Descrição
                          </div>
                          <div class="text-brand-5">
                            {{
                              array?.catalogoItem?.nome ||
                              array?.descricao ||
                              array?.catalogoItemNome
                            }}
                          </div>
                        </div>
                        <div class="col">
                          <div class="text-brand-5 text-weight-bold">Grupo</div>
                          <div class="text-brand-5">
                            {{
                              array.catalogoItem?.catalogoGrupo?.nome ||
                              array.grupo?.nome
                            }}
                          </div>
                        </div>
                      </div>
                      <div class="row col-12 q-gutter-sm q-mt-sm">
                        <div class="col-2">
                          <div class="text-brand-5 text-weight-bold">
                            Patrimônio
                          </div>
                          <div class="text-brand-5">
                            {{ array?.patrimonio }}
                          </div>
                        </div>
                        <div class="col">
                          <div class="text-brand-5 text-weight-bold">Preço</div>
                          <div class="text-brand-5">
                            {{ array?.preco || array?.valor }}
                          </div>
                        </div>
                        <div class="col">
                          <div class="text-brand-5 text-weight-bold">
                            Subgrupo
                          </div>
                          <div class="text-brand-5">
                            {{
                              array.catalogoItem?.catalogoSubGrupo?.nome ||
                              array.subgrupo?.nome
                            }}
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="
                          transferencia ||
                          array?.expandido ||
                          (statusTransferencia != 'criada' &&
                            statusTransferencia != 'enviada' &&
                            statusTransferencia != undefined)
                        "
                        class="row col-12 q-gutter-sm q-mt-sm"
                      >
                        <div class="col-2">
                          <div class="text-brand-5 text-weight-bold">
                            Origem
                          </div>
                          <div class="text-brand-5">
                            {{ array?.origem?.label || array?.origem }}
                          </div>
                        </div>
                        <div class="col">
                          <div>
                            <div class="text-brand-5 text-weight-bold">
                              Operação
                            </div>
                            <q-select
                              v-if="statusTransferencia == 'criada'"
                              v-model="array.operacao"
                              :options="options.operacaoOptions"
                              map-options
                              behavior="menu"
                              dense
                              outlined
                              @update:model-value="verificarAlertaStatus(index)"
                              @blur="
                                index == 0 ? verificarValor('operacao') : ''
                              "
                              option-label="nome"
                              @filter="filterOperacao"
                              use-input
                            />
                            <span v-else>{{
                              array?.operacao?.nome || array?.operacao
                            }}</span>
                          </div>
                        </div>
                        <div class="col">
                          <div class="text-brand-5 text-weight-bold">
                            Status
                          </div>
                          <q-select
                            v-if="statusTransferencia == 'criada'"
                            v-model="array.status"
                            :options="options.statusOptions"
                            map-options
                            behavior="menu"
                            dense
                            outlined
                            @update:model-value="verificarAlertaStatus(index)"
                            @blur="index == 0 ? verificarValor('status') : ''"
                            @filter="filterStatus"
                            use-input
                          />
                          <span v-else>{{ array.status }}</span>
                        </div>
                      </div>
                      <div
                        v-if="deposito && array?.expandido"
                        class="row col-12 q-gutter-sm q-mt-sm"
                      >
                        <div class="col-md-3">
                          <div class="text-brand-5 text-weight-bold">
                            Local de Depósito
                          </div>
                          <q-select
                            v-model="array.deposito"
                            :options="options.depositoOptions"
                            class="input-mobile"
                            option-label="nome"
                            option-value="depositoLocalUuid"
                            dense
                            use-input
                            map-options
                            @blur="index == 0 ? verificarValor('deposito') : ''"
                            outlined
                            label="Selecione o Depósito"
                            label-color="grey-6"
                            behavior="menu"
                            @filter="filtrarDeposito"
                          />
                        </div>
                      </div>
                    </div>
                    <div v-if="tela == 'retirada'" class="col-2">
                      <div class="col">
                        <div class="text-brand-5 text-weight-bold">
                          Documentos
                        </div>
                        <div v-if="array.documentosVinculados?.length > 0">
                          <span :class="{ 'text-red': array?.vencido }">
                            {{ array.documentosVinculados?.length }}
                          </span>
                          <q-tooltip>
                            <div
                              v-for="(
                                documento, index
                              ) in array.documentosVinculados"
                              :key="index"
                            >
                              <div>
                                <span class="row col-12"
                                  >Nome: {{ documento.nome }}</span
                                >
                                <div
                                  :style="
                                    documento.status == 'valido'
                                      ? 'width: fit-content; padding: 0px 0px'
                                      : documento.status == 'vencido'
                                      ? 'width: fit-content; padding: 0px 5px'
                                      : documento.status == 'revalidado'
                                      ? 'width: fit-content; padding: 0px 5px'
                                      : documento.status == 'inativo'
                                      ? 'width: fit-content; padding: 0px 5px'
                                      : ''
                                  "
                                  class="row col-12 items-center"
                                >
                                  <div
                                    v-if="documento.status == 'valido'"
                                    class="elipse-table q-mr-xs bg-positive"
                                  ></div>
                                  <div
                                    v-if="documento.status == 'revalidado'"
                                    class="elipse-table q-mr-xs bg-warning"
                                  ></div>
                                  <div
                                    v-if="documento.status == 'vencido'"
                                    class="elipse-table q-mr-xs"
                                    style="background: red"
                                  ></div>
                                  <div
                                    v-if="documento.status == 'inativo'"
                                    class="elipse-table q-mr-xs"
                                    style="background: #383737"
                                  ></div>
                                  <span
                                    v-if="documento.status != 'inativo'"
                                    class="row justify-center text-white"
                                  >
                                    {{
                                      `${documento.status
                                        ?.substring(0, 1)
                                        .toUpperCase()}${documento.status?.substring(
                                        1
                                      )}`
                                    }}
                                  </span>
                                  <span
                                    v-if="documento.status == 'inativo'"
                                    class="row text-white justify-center"
                                  >
                                    Obsoleto
                                  </span>
                                </div>
                              </div>
                            </div>
                          </q-tooltip>
                        </div>
                        <div v-else>0</div>
                      </div>
                    </div>
                    <div class="col-md-1 q-ml-md">
                      <div
                        style="
                          border: 1px solid #707070;
                          border-radius: 4px;
                          background-color: white;
                          border-radius: 20px;
                          z-index: 3;
                        "
                        class="row col-12 justify-center items-center"
                      >
                        <q-img
                          v-if="(array.urlImagem || array.url) != null"
                          :src="array?.urlImagem || array.url"
                          class="img"
                          fit="contain"
                        ></q-img>
                        <q-img
                          v-else
                          class="img"
                          src="../../../assets/semImagem.jpg"
                        ></q-img>
                      </div>
                      <div
                        v-if="
                          (historico && array?.expandido) ||
                          (statusTransferencia != 'criada' &&
                            statusTransferencia != 'enviada' &&
                            statusTransferencia != undefined)
                        "
                        class="row col justify-center items-center no-wrap"
                      >
                        <span v-if="!mobile" class="text-black text-weight-bold"
                          >Histórico</span
                        >
                        <ModalHistoricoAtivo
                          v-if="tipoTransferencia == 'transferencia_interna'"
                          :ativoUuid="
                            array.ativoUuid || array.ativoFinal.ativoUuid
                          "
                          :tipoTransferencia="tipoTransferencia"
                        />
                        <ModalHistoricoAtivo
                          v-else
                          :ativo="[array.ativoInicial, array.ativoFinal]"
                          :tipoTransferencia="tipoTransferencia"
                        />
                      </div>
                      <div v-if="transferencia && array?.expandido">
                        <div
                          v-if="perguntas"
                          class="row col items-center justify-center"
                        >
                          <span
                            v-if="!mobile"
                            class="text-black text-weight-bold"
                            >Detalhe</span
                          >
                          <q-btn
                            icon="article"
                            color="blue"
                            round
                            flat
                            @click="
                              tipoTransferencia == 'transferencia_interna'
                                ? quasar.notify({
                                    message:
                                      'Não é possivel editar um ativo em uma transferência interna.',
                                    color: 'negative',
                                    actions: [
                                      {
                                        label: 'Fechar',
                                        color: 'white',
                                        handler: () => {
                                          /* ... */
                                        },
                                      },
                                    ],
                                  })
                                : transferenciaOrigemTipo == 'unidade'
                                ? quasar.notify({
                                    message:
                                      'Não é possivel editar um ativo em uma transferência externa de unidade -> fornecedor.',
                                    color: 'negative',
                                    actions: [
                                      {
                                        label: 'Fechar',
                                        color: 'white',
                                        handler: () => {
                                          /* ... */
                                        },
                                      },
                                    ],
                                  })
                                : (rightDrawerOpenDetalheAtivo = true),
                                (editarItemCatalogo = { ...array })
                            "
                          />
                        </div>
                        <div v-else class="row col items-center justify-center">
                          <span class="text-black text-weight-bold"
                            >Detalhe</span
                          >
                          <q-btn
                            icon="article"
                            color="blue"
                            round
                            flat
                            @click="
                              (rightDrawerOpenDetalheItem = true),
                                (editarItemCatalogo = { ...array }),
                                (indexAlterarMultiplicado = index)
                            "
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row col-12" v-if="array.expandido">
                    <div v-if="perguntas != false" class="row col-12">
                      <div class="row col-12">
                        <q-separator style="width: 100%" color="brand-5" />
                        <div class="col-md col-xs-12 q-pa-md">
                          <span class="row col-12 q-mb-md subtitulo-item-texto"
                            >Checklists</span
                          >
                          <div
                            class="row col-12"
                            v-for="(checklist, index2) in array.checkLists"
                            :key="index2"
                          >
                            <div class="row col-12">
                              <div
                                class="row col-12 titulo-pergunta-item-texto"
                              >
                                {{ checklist.nome }}
                              </div>
                              <div class="row col-12">
                                <q-radio
                                  style="padding: 0px"
                                  val="sim"
                                  v-model="checklist.resposta"
                                  label="Sim"
                                  class="radio"
                                  @blur="
                                    index2 == 0 &&
                                    index == 0 &&
                                    tela == 'transferencia'
                                      ? verificarValor('checkLists')
                                      : ''
                                  "
                                  @click="verificarAlertaStatus(index)"
                                />
                                <q-radio
                                  style="padding: 0px"
                                  val="nao"
                                  v-model="checklist.resposta"
                                  label="Não"
                                  class="radio"
                                  @blur="
                                    index2 == 0 &&
                                    index == 0 &&
                                    tela == 'transferencia'
                                      ? verificarValor('checkLists')
                                      : ''
                                  "
                                  @click="verificarAlertaStatus(index)"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <q-separator vertical color="brand-5" />
                        <div class="col-md col-xs-12 q-pa-md">
                          <span class="row col-12 q-mb-md subtitulo-item-texto"
                            >Acessórios</span
                          >
                          <div
                            class="row col-12"
                            v-for="(acessorio, index2) in array?.acessorios"
                            :key="index2"
                          >
                            <div class="row col-12">
                              <div
                                class="row col-12 titulo-pergunta-item-texto"
                              >
                                {{ acessorio.nome ? acessorio.nome : "S/N" }}
                              </div>
                              <div class="row col-12">
                                <q-radio
                                  style="padding: 0px"
                                  val="sim"
                                  v-model="acessorio.resposta"
                                  label="Presente"
                                  class="radio"
                                  @blur="
                                    index2 == 0 &&
                                    index == 0 &&
                                    tela == 'transferencia'
                                      ? verificarValor('acessorios')
                                      : ''
                                  "
                                  @click="verificarAlertaStatus(index)"
                                />
                                <q-radio
                                  style="padding: 0px"
                                  val="nao"
                                  v-model="acessorio.resposta"
                                  label="Ausente"
                                  class="radio"
                                  @blur="
                                    index2 == 0 &&
                                    index == 0 &&
                                    tela == 'transferencia'
                                      ? verificarValor('acessorios')
                                      : ''
                                  "
                                  @click="verificarAlertaStatus(index)"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row col-12" v-if="array.expandido">
                    <div
                      v-if="
                        statusTransferencia != 'criada' &&
                        statusTransferencia != 'enviada' &&
                        statusTransferencia != 'rejeitada' &&
                        statusTransferencia != undefined
                      "
                      class="row col-12"
                    >
                      <div class="row col-12">
                        <div
                          v-if="
                            array?.respostasAcessorioEnvio?.length > 0 ||
                            array?.respostasChecklistEnvio?.length > 0
                          "
                          class="row col-12"
                        >
                          <q-separator style="width: 100%" color="brand-5" />
                          <div
                            class="col-md col-xs-12 q-pa-md"
                            v-if="array?.respostasChecklistEnvio?.length > 0"
                          >
                            <span
                              class="row col-12 q-mb-md subtitulo-item-texto"
                              >Checklists Envio</span
                            >
                            <div
                              class="row col-12"
                              v-for="(
                                checklistEnvio, index2
                              ) in array.respostasChecklistEnvio"
                              :key="index2"
                            >
                              <div class="row col-12">
                                <div
                                  class="row col-12 titulo-pergunta-item-texto"
                                >
                                  {{ checklistEnvio.checkListNome }}
                                </div>
                                <div class="row col-12">
                                  <q-radio
                                    style="padding: 0px"
                                    val="sim"
                                    v-model="checklistEnvio.resposta"
                                    label="Sim"
                                    class="radio"
                                    disable
                                    @blur="
                                      index2 == 0 &&
                                      index == 0 &&
                                      tela == 'transferencia'
                                        ? verificarValor(
                                            'respostasChecklistEnvio'
                                          )
                                        : ''
                                    "
                                    @click="verificarAlertaStatus(index)"
                                  />
                                  <q-radio
                                    style="padding: 0px"
                                    val="nao"
                                    v-model="checklistEnvio.resposta"
                                    label="Não"
                                    disable
                                    class="radio"
                                    @blur="
                                      index2 == 0 &&
                                      index == 0 &&
                                      tela == 'transferencia'
                                        ? verificarValor(
                                            'respostasChecklistEnvio'
                                          )
                                        : ''
                                    "
                                    @click="verificarAlertaStatus(index)"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <q-separator vertical color="brand-5" />
                          <div class="col-md col-xs-12 q-pa-md">
                            <span
                              class="row col-12 q-mb-md subtitulo-item-texto"
                              >Acessórios Envio</span
                            >
                            <div
                              class="row col-12"
                              v-for="(
                                acessorioEnvio, index2
                              ) in array?.respostasAcessorioEnvio"
                              :key="index2"
                            >
                              <div
                                v-if="
                                  array?.respostasAcessorioEnvio?.length > 0
                                "
                                class="row col-12"
                              >
                                <div
                                  class="row col-12 titulo-pergunta-item-texto"
                                >
                                  {{
                                    acessorioEnvio.nomeAcessorio
                                      ? acessorioEnvio.nomeAcessorio
                                      : "S/N"
                                  }}
                                </div>
                                <div class="row col-12">
                                  <q-radio
                                    style="padding: 0px"
                                    val="sim"
                                    v-model="acessorioEnvio.resposta"
                                    label="Presente"
                                    disable
                                    class="radio"
                                    @blur="
                                      index2 == 0 &&
                                      index == 0 &&
                                      tela == 'transferencia'
                                        ? verificarValor(
                                            'respostasAcessorioEnvio'
                                          )
                                        : ''
                                    "
                                  />
                                  <q-radio
                                    style="padding: 0px"
                                    val="nao"
                                    v-model="acessorioEnvio.resposta"
                                    label="Ausente"
                                    class="radio"
                                    disable
                                    @blur="
                                      index2 == 0 &&
                                      index == 0 &&
                                      tela == 'transferencia'
                                        ? verificarValor(
                                            'respostasAcessorioEnvio'
                                          )
                                        : ''
                                    "
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="
                        statusTransferencia != 'criada' &&
                        statusTransferencia != 'enviada' &&
                        statusTransferencia != 'rejeitada' &&
                        statusTransferencia != undefined
                      "
                      class="row col-12"
                    >
                      <div class="row col-12">
                        <div
                          v-if="
                            array?.respostasAcessorioRecebimento?.length > 0 ||
                            array?.respostasChecklistRecebimento?.length > 0
                          "
                          class="row col-12"
                        >
                          <q-separator style="width: 100%" color="brand-5" />
                          <div
                            class="col-md col-xs-12 q-pa-md"
                            v-if="
                              array?.respostasChecklistRecebimento?.length > 0
                            "
                          >
                            <span
                              class="row col-12 q-mb-md subtitulo-item-texto"
                              >Checklists Recebimento</span
                            >
                            <div
                              class="row col-12"
                              v-for="(
                                checklistRecebimento, index2
                              ) in array.respostasChecklistRecebimento"
                              :key="index2"
                            >
                              <div class="row col-12">
                                <div
                                  class="row col-12 titulo-pergunta-item-texto"
                                >
                                  {{ checklistRecebimento.checkListNome }}
                                </div>
                                <div class="row col-12">
                                  <q-radio
                                    style="padding: 0px"
                                    val="sim"
                                    v-model="checklistRecebimento.resposta"
                                    label="Sim"
                                    class="radio"
                                    disable
                                    @blur="
                                      index2 == 0 &&
                                      index == 0 &&
                                      tela == 'transferencia'
                                        ? verificarValor(
                                            'respostasChecklistRecebimento'
                                          )
                                        : ''
                                    "
                                  />
                                  <q-radio
                                    style="padding: 0px"
                                    val="nao"
                                    v-model="checklistRecebimento.resposta"
                                    label="Não"
                                    disable
                                    class="radio"
                                    @blur="
                                      index2 == 0 &&
                                      index == 0 &&
                                      tela == 'transferencia'
                                        ? verificarValor(
                                            'respostasChecklistRecebimento'
                                          )
                                        : ''
                                    "
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <q-separator vertical color="brand-5" />
                          <div class="col-md col-xs-12 q-pa-md">
                            <span
                              class="row col-12 q-mb-md subtitulo-item-texto"
                              >Acessórios Recebimento</span
                            >
                            <div
                              class="row col-12"
                              v-for="(
                                acessorioRecebimento, index2
                              ) in array?.respostasAcessorioRecebimento"
                              :key="index2"
                            >
                              <div
                                v-if="
                                  array?.respostasAcessorioRecebimento?.length >
                                  0
                                "
                                class="row col-12"
                              >
                                <div
                                  class="row col-12 titulo-pergunta-item-texto"
                                >
                                  {{
                                    acessorioRecebimento.nomeAcessorio
                                      ? acessorioRecebimento.nomeAcessorio
                                      : "S/N"
                                  }}
                                </div>
                                <div class="row col-12">
                                  <q-radio
                                    style="padding: 0px"
                                    val="sim"
                                    v-model="acessorioRecebimento.resposta"
                                    label="Presente"
                                    disable
                                    class="radio"
                                    @blur="
                                      index2 == 0 &&
                                      index == 0 &&
                                      tela == 'transferencia'
                                        ? verificarValor(
                                            'respostasAcessorioRecebimento'
                                          )
                                        : ''
                                    "
                                  />
                                  <q-radio
                                    style="padding: 0px"
                                    val="nao"
                                    v-model="acessorioRecebimento.resposta"
                                    label="Ausente"
                                    class="radio"
                                    disable
                                    @blur="
                                      index2 == 0 &&
                                      index == 0 &&
                                      tela == 'transferencia'
                                        ? verificarValor(
                                            'respostasAcessorioRecebimento'
                                          )
                                        : ''
                                    "
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="
                      statusTransferencia == 'criada' ||
                      statusTransferencia == 'enviada' ||
                      statusTransferencia == undefined
                    "
                    class="row col-12"
                  >
                    <div
                      class="row col-12"
                      v-if="
                        (respostas.responderAcessorios == 'sim' &&
                          array?.acessorios?.length > 0) ||
                        (respostas.responderCheckLists == 'sim' &&
                          array?.checkLists?.length > 0) ||
                        botaoInformacoes
                      "
                    >
                      <q-separator style="width: 100%" color="brand-5" />
                      <div
                        class="row col-12 q-pa-sm justify-center"
                        style="cursor: pointer"
                        @click="array.expandido = !array.expandido"
                      >
                        <div class="text-black text-weight-bold">
                          <span>{{
                            array?.expandido
                              ? "Ver Menos Informações"
                              : "Ver Mais Informações"
                          }}</span
                          ><q-icon
                            :name="
                              array?.expandido
                                ? 'arrow_drop_up'
                                : 'arrow_drop_down'
                            "
                            size="30px"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="
                      statusTransferencia != 'criada' &&
                      statusTransferencia != 'enviada' &&
                      statusTransferencia != undefined
                    "
                    class="row col-12"
                  >
                    <div
                      class="row col-12"
                      v-if="
                        array?.respostasAcessorioRecebimento?.length > 0 ||
                        array?.respostasChecklistRecebimento?.length > 0 ||
                        array?.respostasAcessorioEnvio?.length ||
                        array?.respostasChecklistRecebimento?.length > 0
                      "
                    >
                      <q-separator style="width: 100%" color="brand-5" />
                      <div
                        class="row col-12 q-pa-sm justify-center"
                        style="cursor: pointer"
                        @click="array.expandido = !array.expandido"
                      >
                        <div class="text-black text-weight-bold">
                          <span>{{
                            array?.expandido
                              ? "Ver Menos Informações"
                              : "Ver Mais Informações"
                          }}</span
                          ><q-icon
                            :name="
                              array?.expandido
                                ? 'arrow_drop_up'
                                : 'arrow_drop_down'
                            "
                            size="30px"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </q-card>
              </div>
            </div>
          </Transition>
        </div>
      </div>
      <div v-else>
        <div
          v-if="
            arrayRespostas?.length > 0 &&
            (respostas.responderCheckLists == 'sim' ||
              respostas.responderAcessorios == 'sim')
          "
          class="row col-12 text-brand-5 text-weight-bold q-mt-xl"
        >
          <q-expansion-item
            class="rounded-borders col-12"
            v-for="(array, index) in arrayRespostas"
            :key="index"
            :label="`Código: ${
              array?.catalogoItem?.codigo ||
              array?.codigo ||
              array?.catalogoItemCodigo
            } Descrição: ${
              array?.catalogoItem?.nome ||
              array?.descricao ||
              array?.catalogoItemNome
            } Patrimônio: ${array?.patrimonio}`"
          >
            <div
              class="row col-12 justify-between titulo-item-texto text-bold q-mt-sm q-pa-sm borda-top"
              v-if="
                (array?.checkLists?.length > 0 &&
                  respostas.responderCheckLists == 'sim') ||
                (array?.acessorios?.length > 0 &&
                  respostas.responderAcessorios == 'sim')
              "
            >
              <div
                v-if="
                  (array?.checkLists?.length > 0 &&
                    respostas.responderCheckLists == 'sim') ||
                  (array?.acessorios?.length > 0 &&
                    respostas.responderAcessorios == 'sim')
                "
                class="row col-md col-xs-12 justify-end"
              >
                <div
                  class="q-pa-xs"
                  style="border: 2px solid #707070; border-radius: 4px"
                >
                  <q-img
                    v-if="array.urlImagem"
                    :src="array?.urlImagem"
                    class="img"
                  ></q-img>
                  <q-img
                    v-else
                    class="img"
                    src="../../../assets/semImagem.jpg"
                  ></q-img>
                </div>
              </div>
            </div>
            <div class="row col-12 q-pa-sm q-ml-sm">
              <div
                v-if="
                  respostas.responderCheckLists == 'sim' &&
                  array?.checkLists?.length > 0
                "
                class="col-md col-xs-12 subtitulo-item-texto q-mt-md"
              >
                Checklists
              </div>
              <div
                v-if="
                  respostas.responderAcessorios == 'sim' &&
                  array?.acessorios?.length > 0
                "
                class="col-md col-xs-12 subtitulo-item-texto q-mt-md desktop"
              >
                Acessórios
              </div>
            </div>
            <div
              class="row col-12 q-pa-md"
              :class="{
                'borda-bottom':
                  (index + 1 == arrayRespostas?.length &&
                    array.checkLists?.length > 0 &&
                    respostas.responderCheckLists == 'sim') ||
                  (index + 1 == arrayRespostas?.length &&
                    array.acessorios?.length > 0 &&
                    respostas.responderAcessorios == 'sim'),
              }"
            >
              <div
                class="col-md col-xs-12"
                v-if="
                  respostas.responderCheckLists == 'sim' &&
                  array?.checkLists?.length > 0
                "
              >
                <div
                  class="row col-12"
                  v-for="(checklist, index2) in array.checkLists"
                  :key="index2"
                >
                  <div class="row col-12">
                    <div class="row col-12 titulo-pergunta-item-texto">
                      {{ checklist.nome }}
                    </div>
                    <div class="row col-12">
                      <q-radio
                        style="padding: 0px"
                        val="sim"
                        v-model="checklist.resposta"
                        label="Sim"
                        class="radio"
                      />
                      <q-radio
                        style="padding: 0px"
                        val="nao"
                        v-model="checklist.resposta"
                        label="Não"
                        class="radio"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="
                  respostas.responderAcessorios == 'sim' &&
                  array?.acessorios?.length > 0
                "
                class="col-md col-xs-12 subtitulo-item-texto q-my-md mobile"
              >
                Acessórios
              </div>
              <div
                v-if="
                  respostas.responderAcessorios == 'sim' &&
                  array?.acessorios?.length > 0
                "
                class="col-md col-xs-12"
              >
                <div
                  class="row col-12"
                  v-for="(acessorio, index2) in array?.acessorios"
                  :key="index2"
                >
                  <div class="row col-12">
                    <div class="row col-12 titulo-pergunta-item-texto">
                      {{ acessorio.nome ? acessorio.nome : "S/N" }}
                    </div>
                    <div class="row col-12">
                      <q-radio
                        style="padding: 0px"
                        val="sim"
                        v-model="acessorio.resposta"
                        label="Presente"
                        class="radio"
                      />
                      <q-radio
                        style="padding: 0px"
                        val="nao"
                        v-model="acessorio.resposta"
                        label="Ausente"
                        class="radio"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </q-expansion-item>
        </div>
      </div>
    </div>
    <q-dialog v-model="confirm" persistent>
      <q-card
        class="q-pa-sm container-modal-excluir text-brand-5 text-weight-bolder q-pa-xl"
      >
        <q-card-section class="row col-12 justify-center">
          <span class="texto-excluir-pai"
            >DESEJA REPLICAR O VALOR DO CAMPO EM TODOS OS ITENS?</span
          >
        </q-card-section>

        <div class="row col-12 justify-center">
          <q-btn
            no-caps
            label="Sim"
            color="positive"
            v-close-popup
            class="btn-excluir"
            icon="check_circle_outline"
            @click="
              replicarValores(
                tipoReplicar == 'checkLists' || tipoReplicar == 'acessorios'
                  ? arrayObjetos[0][tipoReplicar][0]?.resposta
                  : arrayObjetos[0][tipoReplicar]
              )
            "
          />
          <q-btn
            icon="cancel"
            no-caps
            label="Não"
            color="negative"
            class="btn-excluir q-ml-md"
            v-close-popup
          />
        </div>
      </q-card>
    </q-dialog>

    <ModalAdicionarAtivoItem
      :itemCatalogo="editarItemCatalogo"
      :rightDrawerOpen="rightDrawerOpenDetalheAtivo"
      :tipoModal="'editarAtivo'"
      :fornecedorAlocado="fornecedorAlocado"
      :fornecedor="fornecedorId"
      :catalogoEspecificoUuid="catalogoUuid"
      :unidadeId="unidadeIdEspecifico"
      @fecharModal="rightDrawerOpenDetalheAtivo = false"
      @salvarAlteracoes="salvarAlteracoesItem"
    />

    <ModalAdicionarAtivoItem
      :itemCatalogo="editarItemCatalogo"
      :rightDrawerOpen="rightDrawerOpenDetalheItem"
      :unidadeIdEspecifico="unidadeIdEspecifico"
      :catalogoEspecificoUuid="catalogoUuid"
      :multiplicar="editarItemCatalogo.primario"
      :tipoModal="undefined"
      :validacaoCriacao="true"
      @multiplicarCampo="multiplicarItemCriacao"
      @fecharModal="rightDrawerOpenDetalheItem = false"
      @salvarAlteracoes="salvarAlteracoesItemCriacao"
    />
    <div
      v-if="rightDrawerOpenDetalheAtivo || rightDrawerOpenDetalheItem"
      @click="
        (rightDrawerOpenDetalheAtivo = false),
          (rightDrawerOpenDetalheItem = false)
      "
      class="mascara"
    ></div>
  </div>
</template>

<script>
import { watch, ref, onMounted, computed } from "vue";
import { useQuasar } from "quasar";
import { useStore } from "vuex";

import ModalAdicionarAtivoItem from "./ModalAdicionarAtivoItem.vue";
import ModalHistoricoAtivo from "./ModalHistoricoAtivo.vue";

export default {
  props: {
    etapa: { type: String, required: true },
    transferencia: { type: Boolean, required: false },
    deposito: { type: Boolean, required: false },
    ativosErrosIndicatorNew: { type: Array, required: false },
    atualizar: { type: Number, required: false },
    botaoRemover: { type: Boolean, required: false },
    catalogoUuid: { type: String, required: false },
    unidadeIdEspecifico: { type: Number, required: false },
    expandirCard: { type: Number, required: false },
    tipoTransferencia: { type: String, required: false },
    statusTransferencia: { type: String, required: false },
    fornecedorAlocado: { type: Boolean, required: false },
    verificarOperacao: { type: Boolean, required: false },
    verificarStatus: { type: Boolean, required: false },
    fornecedorId: { type: Number, required: false },
    filtro: { type: String, required: false },
    disable: { type: Boolean, required: false },
    historico: { type: Boolean, required: false },
    perguntas: { type: Boolean, required: false },
    tela: { type: String, required: false },
    arrayRespostas: { type: Array, required: true },
    botaoInformacoes: { type: Boolean },
    transferenciaOrigemTipo: { type: String },
    arrayRejeitados: { type: Array },
    atualizarRejeitados: { type: Number },
    verificar: Number,
    respostas: {
      type: Object,
      required: true,
    },
  },
  emit: [
    "enviarValidacaoRespostas",
    "removerAtivo",
    "salvarAlteracoes",
    "vincularAtivo",
  ],
  components: {
    ModalAdicionarAtivoItem,
    ModalHistoricoAtivo,
  },
  setup(props, { emit }) {
    const quasar = useQuasar();
    const store = useStore();
    const ativosErrosIndicator = computed(() => props.ativosErrosIndicatorNew);
    const arrayObjetos = ref(props.arrayRespostas);
    const editarItemCatalogo = ref({});
    const options = ref({
      statusOptions: [],
      operacaoOptions: [],
    });
    const tipoReplicar = ref("");
    let confirm = ref(false);
    let indexAlterarMultiplicado = ref("");
    let rightDrawerOpenDetalheAtivo = ref(false);
    let rightDrawerOpenDetalheItem = ref(false);
    let mobile = ref(false);
    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const validarRespostaChecklist = () => {
      if (props.verificarStatus) {
        return;
      }
      if (props.respostas.responderCheckLists === "nao") {
        validarRespostaAcessorio();
        return;
      }
      let todasRespostasIguais = true;
      let arrayCardNaoRespondido = [];
      for (let i = 0; i < props.arrayRespostas.length; i++) {
        const checkLists = props.arrayRespostas[i].checkLists;
        for (let j = 0; j < checkLists.length; j++) {
          const resposta = checkLists[j].resposta;
          if (resposta !== "sim" && resposta !== "nao") {
            todasRespostasIguais = false;
            arrayCardNaoRespondido.push(i);
          }
        }
      }
      if (!todasRespostasIguais) {
        arrayCardNaoRespondido.forEach((indice) =>
          adicionarAlertaVisual(indice)
        );
      }
      if (todasRespostasIguais) {
        validarRespostaAcessorio();
        return;
      }
      quasar.notify({
        message: "Responda todos os checklists.",
        color: "negative",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    };

    const validarRespostaAcessorio = () => {
      if (props.respostas.responderAcessorios === "nao") {
        emit("enviarValidacaoRespostas");
        return;
      }
      let todasRespostasIguais = true;
      let arrayCardNaoRespondido = [];
      for (let i = 0; i < props.arrayRespostas.length; i++) {
        const acessorios = props.arrayRespostas[i].acessorios;
        for (let j = 0; j < acessorios.length; j++) {
          const resposta = acessorios[j].resposta;
          if (resposta !== "sim" && resposta !== "nao") {
            todasRespostasIguais = false;
            arrayCardNaoRespondido.push(i);
          }
        }
      }
      if (!todasRespostasIguais) {
        arrayCardNaoRespondido.forEach((indice) =>
          adicionarAlertaVisual(indice)
        );
      }
      if (todasRespostasIguais) {
        emit("enviarValidacaoRespostas");
        return;
      }
      quasar.notify({
        message: "Responda todos os acessórios.",
        color: "negative",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    };

    const validarOperacao = () => {
      if (
        (props.transferencia == undefined ||
          props.transferencia == false ||
          props.transferencia == "") &&
        props.verificarOperacao != true
      ) {
        validarRespostaChecklist();
        return;
      }
      let todasRespostasIguais = true;
      let arrayCardNaoRespondido = [];
      for (let i = 0; i < props.arrayRespostas.length; i++) {
        const item = props.arrayRespostas[i];
        if (item.operacao == undefined) {
          todasRespostasIguais = false;
          arrayCardNaoRespondido.push(i);
        }
      }
      if (!todasRespostasIguais) {
        arrayCardNaoRespondido.forEach((indice) =>
          adicionarAlertaVisual(indice)
        );
      }
      if (todasRespostasIguais) {
        validarStatus();
        validarRespostaChecklist();
        return;
      }
      quasar.notify({
        message: "Selecione a operação.",
        color: "negative",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    };

    const validarStatus = () => {
      if (props.verificarStatus != true) {
        return;
      }
      let todasRespostasIguais = true;
      let arrayCardNaoRespondido = [];
      for (let i = 0; i < props.arrayRespostas.length; i++) {
        const item = props.arrayRespostas[i];
        if (item.status == undefined) {
          todasRespostasIguais = false;
          arrayCardNaoRespondido.push(i);
        }
      }
      if (!todasRespostasIguais) {
        arrayCardNaoRespondido.forEach((indice) =>
          adicionarAlertaVisual(indice)
        );
      }
      if (todasRespostasIguais) {
        emit("enviarValidacaoRespostas");
        return;
      }
      quasar.notify({
        message: "Selecione o status.",
        color: "negative",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    };

    const removerAtivo = (ativo, index) => {
      emit(
        "removerAtivo",
        ativo.ativoUuid || ativo.uuid,
        ativo.primario,
        index
      );
    };

    const listarOperacao = async (val) => {
      try {
        const response = await store.dispatch("ferramentaria/listarOperacao", {
          catalogoUuid: props.catalogoUuid,
          nome: val,
        });
        options.value.operacaoOptions = response.data.resultado.dados;
      } catch (error) {
        console.log(error);
      }
    };

    const listarStatus = async (val) => {
      try {
        const response = await store.dispatch(
          "ferramentaria/listarStatusAtivos",
          {
            catalogoUuid: props.catalogoUuid,
            status: val,
          }
        );
        options.value.statusOptions = [];
        response.data.resultado.dados.forEach((status) => {
          if (status.status != "em_transito" && status.status != "em_uso") {
            options.value.statusOptions.push(status.status);
          }
        });
      } catch (error) {
        console.log(error);
      }
    };

    const salvarAlteracoesItem = (value) => {
      let index = arrayObjetos.value.findIndex(
        (item) => item.ativoUuid == value.ativoUuid
      );
      arrayObjetos.value.splice(index, 1, value);
      emit("salvarAlteracoes", arrayObjetos.value);
      if (props.transferencia) {
        vincularAtivoTransferencia();
      }
    };

    const salvarAlteracoesItemCriacao = (value) => {
      arrayObjetos.value.splice(indexAlterarMultiplicado.value, 1, value);
      emit("salvarAlteracoes", arrayObjetos.value);
    };

    const multiplicarItemCriacao = (value) => {
      let quantidadeMultiplos = arrayObjetos.value.filter(
        (item) => item.uuid == value.itemSelecionado.uuid
      );
      if (value.multiplo == quantidadeMultiplos.length) {
        rightDrawerOpenDetalheItem.value = false;
        return;
      }
      let variacao = value.multiplo - quantidadeMultiplos.length;
      let index = arrayObjetos.value.findIndex(
        (dado) => dado.uuid == value.itemSelecionado.uuid && dado.primario
      );
      if (variacao > 0) {
        let array = [];
        for (let i = 0; i < variacao; i++) {
          array.push({
            primario: false,
            acessorios: value.itemSelecionado.acessorios,
            atributos: value.itemSelecionado.atributos,
            checkLists: value.itemSelecionado.checkLists,
            codigo: value.itemSelecionado.codigo,
            deposito: value.itemSelecionado.deposito,
            descricao: value.itemSelecionado.descricao,
            grupo: value.itemSelecionado.grupo,
            subgrupo: value.itemSelecionado.subgrupo,
            tempoPermanencia: value.itemSelecionado.tempoPermanencia,
            unidadeMedida: value.itemSelecionado.unidadeMedida,
            valorLocacao: value.itemSelecionado.valorLocacao,
            url: value.itemSelecionado.url,
            uuid: value.itemSelecionado.uuid,
            operacao: value.itemSelecionado.operacao,
            status: value.itemSelecionado?.status,
            origem: value.itemSelecionado?.origem,
            patrimonio: value.itemSelecionado?.patrimonio,
            valor: value?.itemSelecionado.valor,
            responsavel: value?.itemSelecionado?.responsavel,
          });
        }
        array.forEach((item) => {
          arrayObjetos.value.splice(index + 1, 0, item);
        });
        rightDrawerOpenDetalheItem.value = false;
      } else {
        let quantidadeRemovida = 0;
        while (Math.abs(variacao) > quantidadeRemovida) {
          arrayObjetos.value.forEach(async (item) => {
            if (Math.abs(variacao) > quantidadeRemovida) {
              if (!item.primario && item.uuid == value.itemSelecionado.uuid) {
                let indexRemover = arrayObjetos.value.findIndex(
                  (dado) =>
                    dado.uuid == value.itemSelecionado.uuid &&
                    dado.primario == false
                );
                arrayObjetos.value.splice(indexRemover, 1);
                quantidadeRemovida++;
              }
            }
          });
        }
        rightDrawerOpenDetalheItem.value = false;
      }
    };

    const listarDeposito = async (val) => {
      const array = [];
      await store.state.org.unidadeData.id;
      try {
        const response = await store.dispatch("ferramentaria/listarDeposito", {
          unidadeId: props.unidadeIdEspecifico,
        });
        response.data.resultado.dados.forEach((deposito) => {
          if (deposito.locais.length > 0) {
            deposito.locais.forEach((value) => {
              array.push({
                nome: value.local,
                depositoLocalUuid: value.depositoLocalUuid,
              });
            });
          }
        });
        options.value.depositoOptions = array.filter((value) => {
          return value.nome
            .trim()
            .toLowerCase()
            .includes(val?.trim().toLowerCase());
        });
      } catch (error) {
        console.log(error);
      }
    };

    const verificarValor = (tipo) => {
      if (confirm.value) {
        return;
      }
      if (arrayObjetos.value.length == 1) {
        return;
      }
      if (arrayObjetos.value[0][tipo] != undefined) {
        confirm.value = true;
        tipoReplicar.value = tipo;
      }
    };

    const replicarValores = (valor) => {
      arrayObjetos.value.forEach((dado) => {
        if (
          tipoReplicar.value == "checkLists" ||
          tipoReplicar.value == "acessorios"
        ) {
          dado[tipoReplicar.value]?.forEach((checklist) => {
            checklist.resposta = valor;
          });
        }

        if (
          tipoReplicar.value != "checkLists" &&
          tipoReplicar.value != "acessorios"
        ) {
          dado[tipoReplicar.value] = valor;
        }
      });
    };

    const adicionarAtributoExpandido = () => {
      arrayObjetos.value.forEach((item) => {
        if (item?.expandido == undefined) {
          item.expandido = true;
        }
        if (item?.ativoFinal == undefined) {
          item.patrimonioInicial == undefined
            ? (item.patrimonioInicial = item?.patrimonio)
            : undefined;
          item.valorInicial == undefined
            ? (item.valorInicial = item?.valor)
            : undefined;
          item.tempoPermanenciaInicial == undefined
            ? (item.tempoPermanenciaInicial = item?.tempoPermanencia)
            : undefined;
          item.valorLocacaoInicial == undefined
            ? (item.valorLocacaoInicial = item?.valorLocacao)
            : undefined;
        }
      });
    };

    const adicionarAlertaVisual = (index) => {
      if (props.tela == undefined) {
        return;
      }
      let card = document.getElementById(`card-${index}`);
      if (card.classList.contains("borda-vermelha")) {
        card.classList.remove("borda-vermelha");
      }
      card.classList.add("borda-vermelha");
    };

    const verificarAlertaStatus = async (index) => {
      let card = document.getElementById(`card-${index}`);
      if (card != null && card?.classList?.contains("borda-vermelha")) {
        let status = true;
        let operacao = true;
        let checklistValidacao = true;
        let acessoriosValidacao = true;
        if (props.verificarStatus != true) {
          checklistValidacao = arrayObjetos.value[index]?.checkLists.every(
            (checklist) =>
              checklist.resposta != null && checklist.resposta != undefined
          );
          acessoriosValidacao = arrayObjetos.value[index]?.acessorios.every(
            (checklist) =>
              checklist.resposta != null && checklist.resposta != undefined
          );
        }
        if (props.transferencia) {
          operacao =
            arrayObjetos.value[index].operacao != undefined ? true : false;
        }
        if (props.verificarStatus) {
          status = arrayObjetos.value[index].status != undefined ? true : false;
        }
        if (props.respostas.responderAcessorios === "nao") {
          acessoriosValidacao = true;
        }
        if (props.respostas.responderCheckLists === "nao") {
          checklistValidacao = true;
        }
        if (checklistValidacao && acessoriosValidacao && operacao && status) {
          card.classList?.remove("borda-vermelha");
        }
      }
    };

    const verificarRejeicao = () => {
      if (props.tela != "transferencia") {
        return;
      }
      arrayObjetos.value.forEach((ativo, index) => {
        let card = document.getElementById(`card-${index}`);
        if (
          props.arrayRejeitados?.some(
            (ativoRejeitado) => ativo.ativoUuid == ativoRejeitado
          )
        ) {
          card.classList?.add("borda-laranja");
          ativo.rejeitadoUsuario = true;
        }
        if (
          !props.arrayRejeitados?.some(
            (ativoRejeitado) => ativo.ativoUuid == ativoRejeitado
          ) &&
          card?.classList?.contains("borda-laranja")
        ) {
          card.classList?.remove("borda-laranja");
        }
      });
    };

    const vincularAtivoTransferencia = () => {
      emit("vincularAtivo");
    };

    watch(
      () => props.verificar,
      () => {
        validarOperacao();
      }
    );

    watch(
      () => props.arrayRespostas,
      (antes, depois) => {
        if (antes.length == depois.length) {
          return;
        }
        if (props.tela != undefined) {
          adicionarAtributoExpandido();
        }
      }
    );

    watch(
      () => props.arrayRespostas,
      () => {
        arrayObjetos.value = [...props.arrayRespostas];
      }
    );

    watch(
      () => props.atualizarRejeitados,
      () => {
        verificarRejeicao();
      }
    );

    watch(
      () => props.expandirCard,
      () => {
        adicionarAtributoExpandido();
      }
    );

    watch(
      () => props.atualizar,
      () => {
        arrayObjetos.value = [...props.arrayRespostas];
      }
    );

    onMounted(() => {
      if (props.tela != undefined) {
        adicionarAtributoExpandido();
      }
    });

    return {
      validarRespostaChecklist,
      validarRespostaAcessorio,
      editarItemCatalogo,
      rightDrawerOpenDetalheItem,
      rightDrawerOpenDetalheAtivo,
      removerAtivo,
      arrayObjetos,
      salvarAlteracoesItem,
      options,
      listarDeposito,
      quasar,
      tipoReplicar,
      validarOperacao,
      salvarAlteracoesItemCriacao,
      multiplicarItemCriacao,
      validarStatus,
      listarStatus,
      mobile,
      indexAlterarMultiplicado,
      adicionarAtributoExpandido,
      confirm,
      ativosErrosIndicator,
      vincularAtivoTransferencia,
      replicarValores,
      verificarValor,
      adicionarAlertaVisual,
      verificarAlertaStatus,
      verificarRejeicao,
      listarOperacao,
      filtrarDeposito(val, update) {
        listarDeposito(val);
        setTimeout(() => {
          update();
        }, 500);
      },
      filterStatus(val, update) {
        listarStatus(val);
        setTimeout(() => {
          update();
        }, 300);
      },
      filterOperacao(val, update) {
        listarOperacao(val);
        setTimeout(() => {
          update();
        }, 300);
      },
    };
  },
};
</script>

<style scoped>
.texto-checklist {
  width: 80px;
}
.titulo-item-texto {
  font-size: 18px;
}
.subtitulo-item-texto {
  font-size: 16px;
  font-weight: bold;
}
.titulo-pergunta-item-texto {
  font-size: 15px;
  word-wrap: break-word;
  word-break: break-all;
}
.borda-top {
  border-top: 2px solid #707070;
}
.borda-bottom {
  border-bottom: 2px solid #707070;
}
.mobile {
  display: none;
}
.img {
  width: 100px;
  height: 100px;
  border-radius: 20px;
}
.expansivel-enter-active,
.expansivel-leave-active {
  transition: height 0.5s;
}

.expansivel-enter,
.expansivel-leave-to {
  height: 0;
  opacity: 0;
}
.borda-vermelha {
  border: 2px solid red !important;
  z-index: 1;
}
.borda-laranja {
  border: 2px solid orange !important;
  z-index: 1;
}
.mascara {
  background-color: black;
  height: 100% !important;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3;
  opacity: 0.4;
}
.container-modal-excluir {
  width: 590px;
}
.elipse-table {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
.texto-excluir-pai {
  text-align: center;
  text-justify: inter-word;
  font-size: 23px;
  font-weight: bold;
  color: black;
}
.texto-excluir-filho {
  text-align: center;
  text-justify: inter-word;
  font-size: 15px;
}
.btn-excluir {
  font-size: 16px;
  padding: 0px 25px;
}
.texto-index-card {
  font-size: 20px;
}
@media (max-width: 1024px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
  .titulo-item-texto {
    font-size: 14px;
  }
  .subtitulo-item-texto {
    font-size: 13px;
  }
  .titulo-pergunta-item-texto {
    font-size: 12px;
    word-break: break-all;
  }
  .radio {
    font-size: 12px;
  }
  .img {
    width: 50px;
    height: 50px;
  }
}
@media (max-width: 600px) {
  .container-modal-excluir {
    width: 100%;
    height: 250px;
    padding: 10px 10px 0px 10px;
    margin: 0px;
    border-radius: 10px;
  }
  .texto-excluir-pai {
    font-size: 17px;
  }
  .texto-excluir-filho {
    font-size: 14px;
  }
  .btn-excluir {
    font-size: 14px;
  }
  .texto-colunas {
    font-size: 10px;
  }
  .texto-index-card {
    font-size: 10px;
  }
}
</style>
